module.exports = __webpack_public_path__ + "static/company-22f0e929eede6cc14df160505c6c7320.jpg";